import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import NoteView from "./NoteView";
import environment from "../AuthEnv";
// import { GC_USER_ID, GC_AUTH_TOKEN } from "../constants";

// import loadable from '@loadable/component';
// const NoteView = loadable(() => import('./NoteView'));

const userNotesQuery = graphql`
  query NoteViewContainerQuery($userId: ID!, $post: ID) {
    user(id: $userId) {
      ...NoteView_user_Notes @arguments(post: $post)
    }
  }
`;

function NoteViewContainer(props) {
  // const uid = localStorage.getItem(GC_USER_ID);
  // const [userId, setUserId] = useState(uid);
  let settings = props.settings;
  const user = props.user;
  const { userId } = props.settings;
  const selectedPostId = props.postId;
  return (
    <QueryRenderer
      environment={environment}
      query={userNotesQuery}
      variables={{ userId: userId, post: selectedPostId }}
      render={({ error, props }) => {
        if (error) {
          return <div>Error!</div>;
        }
        if (!props) {
          return <div></div>;
        }
        return (
          <div>
            <NoteView
              postId={selectedPostId}
              settings={settings}
              user_Notes={props.user}
            />
          </div>
        );
      }}
    />
  );
}

export default NoteViewContainer;
